<template>
  <Teleport to="body">
    <div class="fixed top-4 end-4 z-[9999] flex flex-col gap-2 max-w-sm">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="flex items-center gap-3 px-4 py-3 rounded shadow-lg text-sm font-medium cursor-pointer"
          :class="toastClass(toast.type)"
          @click="dismiss(toast.id)"
        >
          <span class="flex-1">{{ toast.message }}</span>
          <button class="opacity-60 hover:opacity-100 text-lg leading-none">&times;</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const { toasts, dismiss } = useToast();

function toastClass(type: string) {
  switch (type) {
    case 'success': return 'bg-status-success text-white';
    case 'error': return 'bg-status-error text-white';
    case 'warning': return 'bg-status-warning text-white';
    default: return 'bg-brand-primary text-white';
  }
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
